// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Hero map — full-width breakout past the 65px icon nav ── */
.compliance-hero {
    position: relative;
    margin-left: -65px;
    width: calc(100% + 65px);
    min-height: 380px;
    max-height: 520px;
    height: 46vh;
    overflow: hidden;
    background: #0e0c09;
}

/* Bottom fade to page background */
.compliance-hero::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 200px;
    background: linear-gradient(to bottom, transparent 0%, rgba(14, 12, 9, 0.85) 65%, #0e0c09 100%);
    pointer-events: none;
    z-index: 2;
}

/* Suppress the right-side country list — map fills full width in the hero */
.compliance-hero .world-map {
    grid-template-columns: 1fr;
    height: 100%;
    min-height: 0;
}

.compliance-hero .world-map__side {
    display: none;
}

.compliance-hero .world-map__main {
    height: 100%;
}

.compliance-hero .world-map__header {
    display: none;
}

.compliance-hero .world-map__map-shell {
    height: 100%;
    flex: 1;
}

.compliance-hero .svgMap-map-wrapper {
    min-height: 0;
    height: 100%;
}

/* ComplianceFlowMap SVG fills the hero */
.compliance-hero .cfm {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

/* Stats strip overlaid at the bottom of the hero, above the gradient */
.compliance-hero__stats {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 3;
    display: flex;
    align-items: center;
    gap: 0;
    padding: 16px 24px 20px calc(65px + 24px);
}

.compliance-hero__stat {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 0 0 auto;
}

.compliance-hero__stat-value {
    font-size: 1.4rem;
    font-weight: 300;
    color: #e8e8e8;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.02em;
    line-height: 1.1;
}

.compliance-hero__stat-label {
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.3);
}

.compliance-hero__stat-source {
    font-size: 0.6rem;
    color: rgba(255, 255, 255, 0.18);
    letter-spacing: 0.03em;
    margin-top: 1px;
}

.compliance-hero__stat-divider {
    width: 1px;
    height: 32px;
    background: rgba(255, 255, 255, 0.08);
    flex-shrink: 0;
    margin: 0 22px;
}

.compliance-hero__audit-btn {
    margin-left: auto;
    flex-shrink: 0;
    padding: 9px 18px;
    border-radius: 8px;
    border: 1px solid rgba(192, 159, 83, 0.4);
    background: rgba(192, 159, 83, 0.1);
    color: #c0a053;
    font-size: 0.82rem;
    font-weight: 600;
    text-decoration: none;
    letter-spacing: 0.02em;
    backdrop-filter: blur(8px);
    transition: background 0.15s ease, border-color 0.15s ease;
}

.compliance-hero__audit-btn:hover {
    background: rgba(192, 159, 83, 0.2);
    border-color: rgba(192, 159, 83, 0.6);
    text-decoration: none;
}

/* ── Content area below hero ── */
.compliance-page {
    padding-top: 20px;
}

/* ── Pre-consent data transfer section ── */
.compliance-transfers__card {
    padding: 20px 22px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.07);
    background: rgba(24, 22, 18, 0.75);
}

.compliance-transfers__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 20px;
}

.compliance-transfers__header-text {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
}

.compliance-transfers__title {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.88);
    letter-spacing: 0.01em;
}

.compliance-transfers__desc {
    margin: 0;
    font-size: 0.8rem;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.38);
    max-width: 520px;
}

.compliance-transfers__scan-time {
    font-size: 0.67rem;
    color: rgba(255, 255, 255, 0.22);
    font-weight: 500;
}

.compliance-transfers__scan-btn {
    flex-shrink: 0;
    padding: 8px 16px;
    border-radius: 8px;
    border: 1px solid rgba(192, 159, 83, 0.35);
    background: rgba(192, 159, 83, 0.08);
    color: #c0a053;
    font-size: 0.78rem;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    letter-spacing: 0.02em;
    transition: background 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;
}

.compliance-transfers__scan-btn:hover:not(:disabled) {
    background: rgba(192, 159, 83, 0.16);
    border-color: rgba(192, 159, 83, 0.55);
}

.compliance-transfers__scan-btn.--loading,
.compliance-transfers__scan-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* Empty / status states */
.compliance-transfers__empty {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 18px 0 4px;
    font-size: 0.82rem;
    color: rgba(255, 255, 255, 0.3);
}

.compliance-transfers__empty-icon {
    font-size: 1.1rem;
    line-height: 1;
    flex-shrink: 0;
}

.compliance-transfers__empty--loading {
    color: rgba(192, 159, 83, 0.55);
}

.compliance-transfers__empty--clean {
    color: rgba(120, 200, 140, 0.7);
}

/* Transfer rows */
.compliance-transfers__list {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.compliance-transfers__row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 14px;
    border-radius: 8px;
    border: 1px solid rgba(255, 80, 80, 0.15);
    background: rgba(255, 60, 60, 0.05);
}

.compliance-transfers__row-main {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
    min-width: 0;
}

.compliance-transfers__row-service {
    font-size: 0.88rem;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.82);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.compliance-transfers__row-host {
    font-size: 0.7rem;
    color: rgba(255, 255, 255, 0.3);
    font-family: monospace;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Category badge */
.compliance-transfers__row-cat {
    flex-shrink: 0;
    padding: 3px 9px;
    border-radius: 20px;
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    border: 1px solid transparent;
}

.compliance-transfers__row-cat--advertising {
    background: rgba(220, 80, 80, 0.12);
    border-color: rgba(220, 80, 80, 0.3);
    color: rgba(240, 140, 130, 0.9);
}

.compliance-transfers__row-cat--analytics {
    background: rgba(100, 160, 220, 0.1);
    border-color: rgba(100, 160, 220, 0.25);
    color: rgba(140, 190, 240, 0.85);
}

.compliance-transfers__row-cat--social {
    background: rgba(130, 100, 200, 0.1);
    border-color: rgba(130, 100, 200, 0.25);
    color: rgba(175, 150, 230, 0.85);
}

.compliance-transfers__row-cat--other,
.compliance-transfers__row-cat--unknown {
    background: rgba(255, 255, 255, 0.04);
    border-color: rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.35);
}

/* Pre-consent flag */
.compliance-transfers__row-flag {
    flex-shrink: 0;
    padding: 3px 9px;
    border-radius: 20px;
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    background: rgba(220, 100, 60, 0.12);
    border: 1px solid rgba(220, 100, 60, 0.3);
    color: rgba(240, 160, 120, 0.9);
}

@media (max-width: 580px) {
    .compliance-transfers__header {
        flex-direction: column;
        align-items: stretch;
    }

    .compliance-transfers__scan-btn {
        align-self: flex-start;
    }

    .compliance-transfers__row {
        flex-wrap: wrap;
    }
}

/* ── Side-by-side grid ───────────────────────────────────────────────────────── */
.compliance-bottom-grid {
    display: grid;
    grid-template-columns: 3fr 2fr;
    gap: 24px;
    align-items: start;
}

/* When the transfers card is absent (combined view), audit takes full width */
.compliance-bottom-grid > .compliance-page__audit:first-child {
    grid-column: 1 / -1;
}

@media (max-width: 900px) {
    .compliance-bottom-grid {
        grid-template-columns: 1fr;
    }
}

.compliance-page__audit .audit-snapshot-card:hover {
    transform: none;
    border-color: rgba(255, 255, 255, 0.1);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.16);
}

@media (max-width: 680px) {
    .compliance-hero {
        max-height: 60vw;
        min-height: 240px;
    }

    .compliance-hero__stats {
        flex-wrap: wrap;
        gap: 10px 0;
        padding: 12px 16px 16px;
    }

    .compliance-hero__stat-divider {
        display: none;
    }

    .compliance-hero__audit-btn {
        margin-left: 0;
        width: 100%;
        text-align: center;
    }
}

/* ── Tab switcher ────────────────────────────────────────────────────────────── */
.compliance-transfers__tabs {
    display: flex;
    gap: 2px;
    margin-bottom: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
    padding-bottom: 0;
}

.compliance-transfers__tab {
    display: flex;
    align-items: center;
    gap: 7px;
    padding: 8px 14px 10px;
    background: transparent;
    border: none;
    border-bottom: 2px solid transparent;
    color: rgba(255, 255, 255, 0.35);
    font-size: 0.8rem;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    letter-spacing: 0.02em;
    margin-bottom: -1px;
    transition: color 0.15s ease, border-color 0.15s ease;
}

.compliance-transfers__tab:hover {
    color: rgba(255, 255, 255, 0.6);
}

.compliance-transfers__tab.--active {
    color: rgba(255, 255, 255, 0.88);
    border-bottom-color: #c0a053;
}

.compliance-tab-pill {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 18px;
    height: 18px;
    padding: 0 5px;
    border-radius: 9px;
    font-size: 0.62rem;
    font-weight: 700;
    background: rgba(255, 255, 255, 0.08);
    color: rgba(255, 255, 255, 0.45);
}

.compliance-transfers__tab.--active .compliance-tab-pill {
    background: rgba(192, 159, 83, 0.18);
    color: rgba(192, 159, 83, 0.9);
}

/* ── Cookies list ────────────────────────────────────────────────────────────── */
.compliance-cookies__list {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.compliance-cookies__row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.06);
    background: rgba(255, 255, 255, 0.02);
}

.compliance-cookies__row-main {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
    min-width: 0;
}

.compliance-cookies__row-name {
    font-size: 0.82rem;
    font-weight: 600;
    font-family: monospace;
    color: rgba(255, 255, 255, 0.78);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.compliance-cookies__row-domain {
    font-size: 0.68rem;
    color: rgba(255, 255, 255, 0.28);
    font-family: monospace;
    white-space: pre-wrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.compliance-cookies__row-desc {
    font-size: 0.68rem;
    color: rgba(255, 255, 255, 0.38);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-style: italic;
}

.compliance-cookies__row-party {
    flex-shrink: 0;
    padding: 3px 9px;
    border-radius: 20px;
    font-size: 0.62rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    border: 1px solid transparent;
}

.compliance-cookies__row-party.--third {
    background: rgba(220, 80, 80, 0.1);
    border-color: rgba(220, 80, 80, 0.25);
    color: rgba(240, 130, 120, 0.85);
}

.compliance-cookies__row-party.--first {
    background: rgba(255, 255, 255, 0.04);
    border-color: rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.35);
}

.compliance-cookies__row-lifetime {
    flex-shrink: 0;
    font-size: 0.65rem;
    font-weight: 600;
    letter-spacing: 0.04em;
}

.compliance-cookies__row-lifetime.--persistent {
    color: rgba(220, 160, 60, 0.75);
}

.compliance-cookies__row-lifetime.--session {
    color: rgba(255, 255, 255, 0.28);
}

.compliance-cookies__flags {
    display: flex;
    gap: 4px;
    flex-shrink: 0;
    flex-wrap: wrap;
}

.compliance-cookies__flag {
    padding: 2px 7px;
    border-radius: 4px;
    font-size: 0.58rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    background: rgba(80, 144, 220, 0.08);
    border: 1px solid rgba(80, 144, 220, 0.18);
    color: rgba(140, 190, 240, 0.7);
}

@media (max-width: 580px) {
    .compliance-cookies__row {
        flex-wrap: wrap;
    }
    .compliance-cookies__flags {
        width: 100%;
    }
}

/* ── Category summary cards ─────────────────────────────────────────────────── */
.transfers-summary {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 18px;
}

.transfers-summary__card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 12px 18px 10px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.07);
    background: rgba(255, 255, 255, 0.02);
    cursor: pointer;
    font-family: inherit;
    color: inherit;
    transition: background 0.15s ease, border-color 0.15s ease;
    min-width: 76px;
    text-align: center;
}

.transfers-summary__card:hover {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.13);
}

.transfers-summary__card.--active {
    background: color-mix(in srgb, var(--cat-color, #c0a053) 12%, transparent);
    border-color: color-mix(in srgb, var(--cat-color, #c0a053) 40%, transparent);
}

.transfers-summary__card-icon {
    font-size: 0.9rem;
    line-height: 1;
    color: var(--cat-color, rgba(255, 255, 255, 0.5));
}

.transfers-summary__card-count {
    font-size: 1.6rem;
    font-weight: 200;
    color: rgba(255, 255, 255, 0.88);
    line-height: 1;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.02em;
}

.transfers-summary__card-label {
    font-size: 0.6rem;
    font-weight: 700;
    letter-spacing: 0.09em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.35);
}

.transfers-summary__card-risk {
    font-size: 0.58rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    padding: 2px 7px;
    border-radius: 10px;
    margin-top: 2px;
}

.transfers-summary__card-risk.--high {
    background: rgba(220, 80, 80, 0.15);
    color: rgba(240, 130, 120, 0.9);
}

.transfers-summary__card-risk.--medium {
    background: rgba(220, 160, 60, 0.12);
    color: rgba(230, 180, 100, 0.85);
}

.transfers-summary__card-risk.--low {
    background: rgba(80, 168, 120, 0.1);
    color: rgba(120, 200, 150, 0.75);
}

.transfers-summary__clear {
    align-self: center;
    padding: 6px 14px;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.09);
    background: transparent;
    color: rgba(255, 255, 255, 0.35);
    font-size: 0.72rem;
    font-family: inherit;
    cursor: pointer;
    transition: all 0.15s ease;
}

.transfers-summary__clear:hover {
    background: rgba(255, 255, 255, 0.05);
    color: rgba(255, 255, 255, 0.6);
}

/* ── Row additions ───────────────────────────────────────────────────────────── */
.compliance-transfers__row-icon {
    flex-shrink: 0;
    font-size: 0.85rem;
    width: 18px;
    text-align: center;
    line-height: 1;
}

.compliance-transfers__row-resource {
    flex-shrink: 0;
    padding: 2px 8px;
    border-radius: 5px;
    font-size: 0.6rem;
    font-weight: 700;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    background: rgba(255, 255, 255, 0.05);
    color: rgba(255, 255, 255, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.08);
    white-space: nowrap;
}

.compliance-transfers__row-resource--script   { background: rgba(120, 100, 220, 0.1); border-color: rgba(120, 100, 220, 0.2); color: rgba(170, 155, 240, 0.75); }
.compliance-transfers__row-resource--xhr,
.compliance-transfers__row-resource--fetch    { background: rgba(220, 160, 60, 0.08); border-color: rgba(220, 160, 60, 0.18); color: rgba(230, 185, 100, 0.7);  }
.compliance-transfers__row-resource--image    { background: rgba(80, 168, 120, 0.07); border-color: rgba(80, 168, 120, 0.16); color: rgba(120, 200, 150, 0.65); }
.compliance-transfers__row-resource--font     { background: rgba(255, 255, 255, 0.04); border-color: rgba(255, 255, 255, 0.09); color: rgba(255, 255, 255, 0.28); }
.compliance-transfers__row-resource--stylesheet { background: rgba(80, 144, 220, 0.07); border-color: rgba(80, 144, 220, 0.16); color: rgba(140, 190, 240, 0.65); }

/* ── EU / Non-EU region badge ────────────────────────────────────────────────── */
.compliance-transfers__row-region {
    flex-shrink: 0;
    padding: 2px 8px;
    border-radius: 5px;
    font-size: 0.6rem;
    font-weight: 700;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    white-space: nowrap;
    border: 1px solid transparent;
}

.compliance-transfers__row-region.--eu {
    background: rgba(80, 168, 120, 0.08);
    border-color: rgba(80, 168, 120, 0.2);
    color: rgba(120, 200, 150, 0.7);
}

.compliance-transfers__row-region.--non-eu {
    background: rgba(220, 140, 50, 0.1);
    border-color: rgba(220, 140, 50, 0.22);
    color: rgba(230, 175, 100, 0.8);
}

/* ── Extra category colours ──────────────────────────────────────────────────── */
.compliance-transfers__row--cmp {
    border-color: rgba(80, 168, 120, 0.12);
    background: rgba(80, 168, 120, 0.03);
}

.compliance-transfers__row-cat--cmp {
    background: rgba(80, 168, 120, 0.1);
    border-color: rgba(80, 168, 120, 0.25);
    color: rgba(120, 200, 150, 0.85);
}

.compliance-transfers__row-cat--fingerprinting {
    background: rgba(192, 54, 90, 0.12);
    border-color: rgba(192, 54, 90, 0.3);
    color: rgba(230, 120, 150, 0.9);
}

.compliance-transfers__row-cat--functional {
    background: rgba(80, 168, 120, 0.08);
    border-color: rgba(80, 168, 120, 0.2);
    color: rgba(120, 200, 150, 0.8);
}

.compliance-transfers__row-cat--cdn {
    background: rgba(150, 150, 150, 0.07);
    border-color: rgba(150, 150, 150, 0.18);
    color: rgba(180, 180, 180, 0.55);
}

.compliance-transfers__row-cat--third-party {
    background: rgba(255, 255, 255, 0.04);
    border-color: rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.32);
}

@media (max-width: 580px) {
    .transfers-summary {
        gap: 6px;
    }

    .transfers-summary__card {
        min-width: 64px;
        padding: 10px 12px 8px;
    }

    .compliance-transfers__row-resource,
    .compliance-transfers__row-region {
        display: none;
    }
}

/* ── Combined-view placeholder ──────────────────────────────────────────────── */
.compliance-transfers__combined-placeholder {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 28px 22px;
    color: rgba(255, 255, 255, 0.3);
    font-size: 0.82rem;
    line-height: 1.5;
}

.compliance-transfers__combined-placeholder p {
    margin: 0;
    max-width: 440px;
}

.compliance-transfers__combined-placeholder-icon {
    font-size: 1.4rem;
    flex-shrink: 0;
    opacity: 0.35;
}

/* ── Header actions (export + scan) ─────────────────────────────────────────── */
.compliance-transfers__header-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.compliance-transfers__export-btn {
    padding: 8px 14px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(255, 255, 255, 0.04);
    color: rgba(255, 255, 255, 0.45);
    font-size: 0.75rem;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    letter-spacing: 0.02em;
    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
    white-space: nowrap;
}

.compliance-transfers__export-btn:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.18);
    color: rgba(255, 255, 255, 0.75);
}

/* ── Cookie table actions ────────────────────────────────────────────────────── */
.compliance-cookies__table-actions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 8px;
}

/* ── Scan history ────────────────────────────────────────────────────────────── */
.compliance-transfers__history {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    padding: 10px 0 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    margin-bottom: 4px;
}

.compliance-transfers__history-label {
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.09em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.2);
    margin-right: 4px;
    flex-shrink: 0;
}

.compliance-transfers__history-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.07);
    background: rgba(255, 255, 255, 0.02);
    font-size: 0.7rem;
    color: rgba(255, 255, 255, 0.35);
}

.compliance-transfers__history-chip-detail {
    color: rgba(255, 255, 255, 0.2);
}

/* ── Search input ────────────────────────────────────────────────────────────── */
.compliance-search {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
}

.compliance-search__input {
    flex: 1;
    padding: 8px 12px;
    border-radius: 7px;
    border: 1px solid rgba(255, 255, 255, 0.09);
    background: rgba(255, 255, 255, 0.03);
    color: rgba(255, 255, 255, 0.75);
    font-size: 0.8rem;
    font-family: inherit;
    outline: none;
    transition: border-color 0.15s ease, background 0.15s ease;
    min-width: 0;
}

.compliance-search__input::placeholder {
    color: rgba(255, 255, 255, 0.2);
}

.compliance-search__input:focus {
    border-color: rgba(192, 159, 83, 0.4);
    background: rgba(255, 255, 255, 0.05);
}

.compliance-search__input::-webkit-search-cancel-button {
    filter: invert(0.5);
    cursor: pointer;
}

.compliance-search__count {
    font-size: 0.68rem;
    color: rgba(255, 255, 255, 0.3);
    white-space: nowrap;
    flex-shrink: 0;
}

/* ── List column headers ─────────────────────────────────────────────────────── */
.compliance-transfers__list-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 4px 14px 6px;
    font-size: 0.6rem;
    font-weight: 700;
    letter-spacing: 0.09em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.2);
}

.compliance-transfers__list-header > span:first-child { width: 18px; flex-shrink: 0; }
.compliance-transfers__list-header > span:nth-child(2) { flex: 1; min-width: 0; }
.compliance-transfers__list-header > span:last-child   { width: 18px; flex-shrink: 0; }

.compliance-cookies__list-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 4px 14px 6px;
    font-size: 0.6rem;
    font-weight: 700;
    letter-spacing: 0.09em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.2);
}

.compliance-cookies__list-header > span:first-child { flex: 1; min-width: 0; }

/* ── Expandable transfer rows ────────────────────────────────────────────────── */
.compliance-transfers__row-wrap {
    display: flex;
    flex-direction: column;
}

.compliance-transfers__row {
    cursor: pointer;
    transition: background 0.12s ease, border-color 0.12s ease;
}

.compliance-transfers__row:hover,
.compliance-transfers__row.--expanded {
    background: rgba(255, 80, 80, 0.08);
    border-color: rgba(255, 80, 80, 0.22);
}

.compliance-transfers__row-toggle {
    flex-shrink: 0;
    font-size: 0.65rem;
    color: rgba(255, 255, 255, 0.25);
    width: 14px;
    text-align: center;
    transition: color 0.12s ease;
}

.compliance-transfers__row:hover .compliance-transfers__row-toggle,
.compliance-transfers__row.--expanded .compliance-transfers__row-toggle {
    color: rgba(255, 255, 255, 0.5);
}

.compliance-transfers__row-detail {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 20px;
    padding: 10px 14px 12px 44px;
    border: 1px solid rgba(255, 80, 80, 0.12);
    border-top: none;
    border-radius: 0 0 8px 8px;
    background: rgba(255, 255, 255, 0.02);
}

.compliance-transfers__row-detail-item {
    display: flex;
    flex-direction: column;
    gap: 3px;
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.55);
}

.compliance-transfers__row-detail-item--full {
    width: 100%;
}

.compliance-transfers__row-detail-label {
    font-size: 0.58rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.2);
}

.compliance-transfers__row-detail-code {
    font-family: monospace;
    font-size: 0.72rem;
    color: rgba(192, 159, 83, 0.75);
    word-break: break-all;
    white-space: pre-wrap;
}

.compliance-transfers__row-detail-privacy {
    font-size: 0.72rem;
    color: rgba(80, 144, 220, 0.8);
    text-decoration: none;
}
.compliance-transfers__row-detail-privacy:hover {
    color: rgba(80, 144, 220, 1);
    text-decoration: underline;
}

/* ── Consent / banner category badge ────────────────────────────────────────── */
.compliance-banner-cat {
    flex-shrink: 0;
    padding: 2px 8px;
    border-radius: 5px;
    font-size: 0.6rem;
    font-weight: 700;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    white-space: nowrap;
    border: 1px solid color-mix(in srgb, var(--bc-color, #909090) 35%, transparent);
    background: color-mix(in srgb, var(--bc-color, #909090) 10%, transparent);
    color: color-mix(in srgb, var(--bc-color, #909090) 90%, #fff);
}

/* ── Pagination controls ─────────────────────────────────────────────────────── */
.compliance-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 14px 0 2px;
}

.compliance-pagination__btn {
    padding: 5px 14px;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.09);
    background: transparent;
    color: rgba(255, 255, 255, 0.45);
    font-size: 0.75rem;
    font-family: inherit;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.compliance-pagination__btn:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.06);
    color: rgba(255, 255, 255, 0.75);
    border-color: rgba(255, 255, 255, 0.16);
}

.compliance-pagination__btn:disabled {
    opacity: 0.25;
    cursor: not-allowed;
}

.compliance-pagination__info {
    font-size: 0.72rem;
    color: rgba(255, 255, 255, 0.3);
    font-variant-numeric: tabular-nums;
    min-width: 52px;
    text-align: center;
}

/* ── Embed modal ─────────────────────────────────────────────────────────────── */
.compliance-embed-modal__overlay {
    position: fixed;
    inset: 0;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.65);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
}

.compliance-embed-modal {
    background: #1a1a2e;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 28px 28px 24px;
    width: 100%;
    max-width: 560px;
    box-shadow: 0 24px 64px rgba(0, 0, 0, 0.5);
}

.compliance-embed-modal__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
}

.compliance-embed-modal__title {
    font-size: 0.95rem;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.9);
    margin: 0;
}

.compliance-embed-modal__close {
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.35);
    font-size: 1rem;
    cursor: pointer;
    padding: 4px;
    line-height: 1;
    transition: color 0.15s ease;
}

.compliance-embed-modal__close:hover {
    color: rgba(255, 255, 255, 0.75);
}

.compliance-embed-modal__desc {
    font-size: 0.82rem;
    color: rgba(255, 255, 255, 0.5);
    margin: 0 0 16px;
    line-height: 1.55;
}

.compliance-embed-modal__desc strong {
    color: rgba(255, 255, 255, 0.8);
    font-weight: 600;
}

.compliance-embed-modal__code {
    background: rgba(0, 0, 0, 0.35);
    border: 1px solid rgba(255, 255, 255, 0.07);
    border-radius: 8px;
    padding: 14px 16px;
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.75);
    white-space: pre-wrap;
    word-break: break-all;
    margin: 0 0 16px;
    line-height: 1.6;
}

.compliance-embed-modal__actions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 14px;
}

.compliance-embed-modal__copy-btn {
    padding: 9px 18px;
    border-radius: 8px;
    border: none;
    background: rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.85);
    font-size: 0.8rem;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    letter-spacing: 0.02em;
    transition: background 0.15s ease, color 0.15s ease;
}

.compliance-embed-modal__copy-btn:hover {
    background: rgba(255, 255, 255, 0.16);
}

.compliance-embed-modal__hint {
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.28);
    margin: 0;
    line-height: 1.5;
}

.compliance-embed-modal__hint code {
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    font-size: 0.72rem;
    background: rgba(255, 255, 255, 0.06);
    padding: 1px 5px;
    border-radius: 4px;
}

/* ── Cookie table actions gap ────────────────────────────────────────────────── */
.compliance-cookies__table-actions {
    gap: 8px;
}

/* ── Cookie row wrap ─────────────────────────────────────────────────────────── */
.compliance-cookies__row-wrap {
    display: flex;
    flex-direction: column;
}

.compliance-cookies__row--unknown {
    border-color: rgba(220, 160, 60, 0.2);
    background: rgba(220, 160, 60, 0.04);
    border-left: 3px solid rgba(220, 160, 60, 0.35);
}

/* ── Vendor line in cookie row ───────────────────────────────────────────────── */
.compliance-cookies__row-vendor {
    font-size: 0.65rem;
    color: rgba(192, 159, 83, 0.7);
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ── Unknown category badge ──────────────────────────────────────────────────── */
.compliance-cookies__unknown-badge {
    flex-shrink: 0;
    padding: 2px 8px;
    border-radius: 5px;
    font-size: 0.6rem;
    font-weight: 700;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    white-space: nowrap;
    border: 1px solid rgba(220, 160, 60, 0.22);
    background: rgba(220, 160, 60, 0.06);
    color: rgba(230, 180, 100, 0.55);
}

/* ── Edit button on cookie row ───────────────────────────────────────────────── */
.compliance-cookies__edit-btn {
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 5px;
    color: rgba(255, 255, 255, 0.3);
    font-size: 0.8rem;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-family: inherit;
    padding: 0;
    line-height: 1;
    transition: color 0.12s ease, border-color 0.12s ease, background 0.12s ease;
}

.compliance-cookies__row--unknown .compliance-cookies__edit-btn {
    background: rgba(220, 160, 60, 0.07);
    border-color: rgba(220, 160, 60, 0.25);
    color: rgba(220, 160, 60, 0.6);
}

.compliance-cookies__edit-btn:hover,
.compliance-cookies__edit-btn.--active {
    color: rgba(192, 159, 83, 0.9);
    border-color: rgba(192, 159, 83, 0.35);
    background: rgba(192, 159, 83, 0.08);
}

/* ── Inline edit panel ───────────────────────────────────────────────────────── */
.compliance-cookies__edit-panel {
    display: flex;
    align-items: flex-end;
    gap: 10px;
    padding: 10px 14px 12px;
    border: 1px solid rgba(192, 159, 83, 0.15);
    border-top: none;
    border-radius: 0 0 8px 8px;
    background: rgba(192, 159, 83, 0.03);
    flex-wrap: wrap;
}

.compliance-cookies__edit-fields {
    display: flex;
    gap: 10px;
    flex: 1;
    flex-wrap: wrap;
    min-width: 0;
}

.compliance-cookies__edit-field {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 120px;
}

.compliance-cookies__edit-field--wide {
    flex: 1;
    min-width: 180px;
}

.compliance-cookies__edit-label {
    font-size: 0.58rem;
    font-weight: 700;
    letter-spacing: 0.09em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.22);
}

.compliance-cookies__edit-input,
.compliance-cookies__edit-select {
    padding: 6px 10px;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.09);
    background: rgba(255, 255, 255, 0.04);
    color: rgba(255, 255, 255, 0.75);
    font-size: 0.78rem;
    font-family: inherit;
    outline: none;
    transition: border-color 0.15s ease;
}

.compliance-cookies__edit-input:focus,
.compliance-cookies__edit-select:focus {
    border-color: rgba(192, 159, 83, 0.4);
}

.compliance-cookies__edit-select option {
    background: #1a1a2e;
    color: rgba(255, 255, 255, 0.75);
}

.compliance-cookies__edit-actions {
    display: flex;
    gap: 6px;
    flex-shrink: 0;
    align-items: flex-end;
}

.compliance-cookies__edit-save {
    padding: 6px 14px;
    border-radius: 6px;
    border: 1px solid rgba(192, 159, 83, 0.35);
    background: rgba(192, 159, 83, 0.1);
    color: #c0a053;
    font-size: 0.75rem;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    letter-spacing: 0.02em;
    transition: background 0.15s ease, border-color 0.15s ease;
}

.compliance-cookies__edit-save:hover {
    background: rgba(192, 159, 83, 0.18);
    border-color: rgba(192, 159, 83, 0.55);
}

.compliance-cookies__edit-cancel {
    padding: 6px 12px;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: transparent;
    color: rgba(255, 255, 255, 0.35);
    font-size: 0.75rem;
    font-family: inherit;
    cursor: pointer;
    transition: color 0.15s ease, background 0.15s ease;
}

.compliance-cookies__edit-cancel:hover {
    background: rgba(255, 255, 255, 0.05);
    color: rgba(255, 255, 255, 0.6);
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Compliance/Style.css"],"names":[],"mappings":"AAAA,gEAAgE;AAChE;IACI,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,mCAAmC;AACnC;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,+FAA+F;IAC/F,oBAAoB;IACpB,UAAU;AACd;;AAEA,4EAA4E;AAC5E;IACI,0BAA0B;IAC1B,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,OAAO;AACX;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA,yCAAyC;AACzC;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA,uEAAuE;AACvE;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,MAAM;IACN,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kCAAkC;IAClC,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;IAChC,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,qCAAqC;IACrC,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;IACzC,mCAAmC;IACnC,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;IACtB,0BAA0B;IAC1B,0DAA0D;AAC9D;;AAEA;IACI,mCAAmC;IACnC,qCAAqC;IACrC,qBAAqB;AACzB;;AAEA,kCAAkC;AAClC;IACI,iBAAiB;AACrB;;AAEA,4CAA4C;AAC5C;IACI,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;IAC1C,oCAAoC;IACpC,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,sBAAsB;IACtB,8EAA8E;AAClF;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;AACnC;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,yCAAyC;IACzC,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,mBAAmB;AACnB;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,mCAAmC;IACnC,oCAAoC;IACpC,+BAA+B;AACnC;;AAEA;IACI,oCAAoC;IACpC,uCAAuC;IACvC,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,uCAAuC;IACvC,gCAAgC;AACpC;;AAEA;;IAEI,qCAAqC;IACrC,sCAAsC;IACtC,gCAAgC;AACpC;;AAEA,qBAAqB;AACrB;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,oCAAoC;IACpC,yCAAyC;IACzC,+BAA+B;AACnC;;AAEA;IACI;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,mFAAmF;AACnF;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;AACtB;;AAEA,8EAA8E;AAC9E;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,eAAe;IACf,sCAAsC;IACtC,0CAA0C;AAC9C;;AAEA;IACI;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,uBAAuB;IAC3B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,WAAW;QACX,kBAAkB;IACtB;AACJ;;AAEA,mFAAmF;AACnF;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,kDAAkD;IAClD,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,oCAAoC;IACpC,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,qDAAqD;AACzD;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;IAChC,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,8BAA8B;AAClC;;AAEA,mFAAmF;AACnF;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,2CAA2C;IAC3C,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;IAClC,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,oCAAoC;IACpC,0CAA0C;IAC1C,+BAA+B;AACnC;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,WAAW;IACf;AACJ;;AAEA,kFAAkF;AAClF;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;IACnB,2CAA2C;IAC3C,qCAAqC;IACrC,eAAe;IACf,oBAAoB;IACpB,cAAc;IACd,0DAA0D;IAC1D,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA;IACI,0EAA0E;IAC1E,4EAA4E;AAChF;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iDAAiD;AACrD;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,cAAc;IACd,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mCAAmC;IACnC,+BAA+B;AACnC;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,mCAAmC;IACnC,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,uBAAuB;IACvB,gCAAgC;IAChC,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA,mFAAmF;AACnF;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,qCAAqC;IACrC,+BAA+B;IAC/B,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA,gDAAgD,oCAAoC,EAAE,sCAAsC,EAAE,gCAAgC,EAAE;AAChK;gDACgD,oCAAoC,EAAE,sCAAsC,EAAE,+BAA+B,GAAG;AAChK,gDAAgD,oCAAoC,EAAE,sCAAsC,EAAE,gCAAgC,EAAE;AAChK,gDAAgD,qCAAqC,EAAE,uCAAuC,EAAE,gCAAgC,EAAE;AAClK,kDAAkD,oCAAoC,EAAE,sCAAsC,EAAE,gCAAgC,EAAE;;AAElK,mFAAmF;AACnF;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,mCAAmC;IACnC,sCAAsC;IACtC,+BAA+B;AACnC;;AAEA,mFAAmF;AACnF;IACI,sCAAsC;IACtC,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;IACnC,sCAAsC;IACtC,gCAAgC;AACpC;;AAEA;IACI,mCAAmC;IACnC,oCAAoC;IACpC,+BAA+B;AACnC;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;IACvC,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,gCAAgC;AACpC;;AAEA;IACI;QACI,QAAQ;IACZ;;IAEA;QACI,eAAe;QACf,sBAAsB;IAC1B;;IAEA;;QAEI,aAAa;IACjB;AACJ;;AAEA,kFAAkF;AAClF;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;AACjB;;AAEA,kFAAkF;AAClF;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;IAC1C,qCAAqC;IACrC,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,sBAAsB;IACtB,4EAA4E;IAC5E,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;IACvC,gCAAgC;AACpC;;AAEA,mFAAmF;AACnF;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA,mFAAmF;AACnF;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;IACR,oBAAoB;IACpB,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;IAC/B,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,qCAAqC;IACrC,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA,mFAAmF;AACnF;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,qCAAqC;IACrC,gCAAgC;IAChC,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb,0DAA0D;IAC1D,YAAY;AAChB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qCAAqC;IACrC,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,mBAAmB;IACnB,cAAc;AAClB;;AAEA,mFAAmF;AACnF;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA,wDAAwD,WAAW,EAAE,cAAc,EAAE;AACrF,yDAAyD,OAAO,EAAE,YAAY,EAAE;AAChF,yDAAyD,WAAW,EAAE,cAAc,EAAE;;AAEtF;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA,sDAAsD,OAAO,EAAE,YAAY,EAAE;;AAE7E,mFAAmF;AACnF;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,0DAA0D;AAC9D;;AAEA;;IAEI,mCAAmC;IACnC,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gCAAgC;IAChC,WAAW;IACX,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd,4BAA4B;IAC5B,yCAAyC;IACzC,gBAAgB;IAChB,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,+BAA+B;IAC/B,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,qBAAqB;AACzB;AACA;IACI,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA,kFAAkF;AAClF;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,+EAA+E;IAC/E,yEAAyE;IACzE,6DAA6D;AACjE;;AAEA,mFAAmF;AACnF;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,uBAAuB;IACvB,gCAAgC;IAChC,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,4EAA4E;AAChF;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;IAChC,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,kCAAkC;IAClC,eAAe;IACf,kBAAkB;AACtB;;AAEA,mFAAmF;AACnF;IACI,eAAe;IACf,QAAQ;IACR,aAAa;IACb,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,0CAA0C;IAC1C,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;IAC/B,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;IAChC,eAAe;IACf,eAAe;IACf,YAAY;IACZ,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,2CAA2C;IAC3C,kBAAkB;IAClB,kBAAkB;IAClB,2DAA2D;IAC3D,kBAAkB;IAClB,gCAAgC;IAChC,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,oCAAoC;IACpC,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,sBAAsB;IACtB,mDAAmD;AACvD;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,2DAA2D;IAC3D,kBAAkB;IAClB,qCAAqC;IACrC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,mFAAmF;AACnF;IACI,QAAQ;AACZ;;AAEA,mFAAmF;AACnF;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,qCAAqC;IACrC,oCAAoC;IACpC,+CAA+C;AACnD;;AAEA,mFAAmF;AACnF;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,mFAAmF;AACnF;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;IAC1C,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA,mFAAmF;AACnF;IACI,cAAc;IACd,qCAAqC;IACrC,0CAA0C;IAC1C,kBAAkB;IAClB,+BAA+B;IAC/B,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,oBAAoB;IACpB,UAAU;IACV,cAAc;IACd,4EAA4E;AAChF;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;IACtC,8BAA8B;AAClC;;AAEA;;IAEI,8BAA8B;IAC9B,sCAAsC;IACtC,oCAAoC;AACxC;;AAEA,mFAAmF;AACnF;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,uBAAuB;IACvB,0CAA0C;IAC1C,gBAAgB;IAChB,0BAA0B;IAC1B,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,OAAO;IACP,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,qCAAqC;IACrC,gCAAgC;IAChC,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,mCAAmC;AACvC;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;IAC1C,mCAAmC;IACnC,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,sBAAsB;IACtB,0DAA0D;AAC9D;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,uBAAuB;IACvB,gCAAgC;IAChC,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,mDAAmD;AACvD;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;AACnC","sourcesContent":["/* ── Hero map — full-width breakout past the 65px icon nav ── */\n.compliance-hero {\n    position: relative;\n    margin-left: -65px;\n    width: calc(100% + 65px);\n    min-height: 380px;\n    max-height: 520px;\n    height: 46vh;\n    overflow: hidden;\n    background: #0e0c09;\n}\n\n/* Bottom fade to page background */\n.compliance-hero::after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 200px;\n    background: linear-gradient(to bottom, transparent 0%, rgba(14, 12, 9, 0.85) 65%, #0e0c09 100%);\n    pointer-events: none;\n    z-index: 2;\n}\n\n/* Suppress the right-side country list — map fills full width in the hero */\n.compliance-hero .world-map {\n    grid-template-columns: 1fr;\n    height: 100%;\n    min-height: 0;\n}\n\n.compliance-hero .world-map__side {\n    display: none;\n}\n\n.compliance-hero .world-map__main {\n    height: 100%;\n}\n\n.compliance-hero .world-map__header {\n    display: none;\n}\n\n.compliance-hero .world-map__map-shell {\n    height: 100%;\n    flex: 1;\n}\n\n.compliance-hero .svgMap-map-wrapper {\n    min-height: 0;\n    height: 100%;\n}\n\n/* ComplianceFlowMap SVG fills the hero */\n.compliance-hero .cfm {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n/* Stats strip overlaid at the bottom of the hero, above the gradient */\n.compliance-hero__stats {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 3;\n    display: flex;\n    align-items: center;\n    gap: 0;\n    padding: 16px 24px 20px calc(65px + 24px);\n}\n\n.compliance-hero__stat {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    flex: 0 0 auto;\n}\n\n.compliance-hero__stat-value {\n    font-size: 1.4rem;\n    font-weight: 300;\n    color: #e8e8e8;\n    font-variant-numeric: tabular-nums;\n    letter-spacing: -0.02em;\n    line-height: 1.1;\n}\n\n.compliance-hero__stat-label {\n    font-size: 0.65rem;\n    font-weight: 700;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.3);\n}\n\n.compliance-hero__stat-source {\n    font-size: 0.6rem;\n    color: rgba(255, 255, 255, 0.18);\n    letter-spacing: 0.03em;\n    margin-top: 1px;\n}\n\n.compliance-hero__stat-divider {\n    width: 1px;\n    height: 32px;\n    background: rgba(255, 255, 255, 0.08);\n    flex-shrink: 0;\n    margin: 0 22px;\n}\n\n.compliance-hero__audit-btn {\n    margin-left: auto;\n    flex-shrink: 0;\n    padding: 9px 18px;\n    border-radius: 8px;\n    border: 1px solid rgba(192, 159, 83, 0.4);\n    background: rgba(192, 159, 83, 0.1);\n    color: #c0a053;\n    font-size: 0.82rem;\n    font-weight: 600;\n    text-decoration: none;\n    letter-spacing: 0.02em;\n    backdrop-filter: blur(8px);\n    transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.compliance-hero__audit-btn:hover {\n    background: rgba(192, 159, 83, 0.2);\n    border-color: rgba(192, 159, 83, 0.6);\n    text-decoration: none;\n}\n\n/* ── Content area below hero ── */\n.compliance-page {\n    padding-top: 20px;\n}\n\n/* ── Pre-consent data transfer section ── */\n.compliance-transfers__card {\n    padding: 20px 22px;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.07);\n    background: rgba(24, 22, 18, 0.75);\n}\n\n.compliance-transfers__header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 20px;\n    margin-bottom: 20px;\n}\n\n.compliance-transfers__header-text {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    min-width: 0;\n}\n\n.compliance-transfers__title {\n    margin: 0;\n    font-size: 1rem;\n    font-weight: 600;\n    color: rgba(255, 255, 255, 0.88);\n    letter-spacing: 0.01em;\n}\n\n.compliance-transfers__desc {\n    margin: 0;\n    font-size: 0.8rem;\n    line-height: 1.5;\n    color: rgba(255, 255, 255, 0.38);\n    max-width: 520px;\n}\n\n.compliance-transfers__scan-time {\n    font-size: 0.67rem;\n    color: rgba(255, 255, 255, 0.22);\n    font-weight: 500;\n}\n\n.compliance-transfers__scan-btn {\n    flex-shrink: 0;\n    padding: 8px 16px;\n    border-radius: 8px;\n    border: 1px solid rgba(192, 159, 83, 0.35);\n    background: rgba(192, 159, 83, 0.08);\n    color: #c0a053;\n    font-size: 0.78rem;\n    font-weight: 600;\n    font-family: inherit;\n    cursor: pointer;\n    letter-spacing: 0.02em;\n    transition: background 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;\n}\n\n.compliance-transfers__scan-btn:hover:not(:disabled) {\n    background: rgba(192, 159, 83, 0.16);\n    border-color: rgba(192, 159, 83, 0.55);\n}\n\n.compliance-transfers__scan-btn.--loading,\n.compliance-transfers__scan-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* Empty / status states */\n.compliance-transfers__empty {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 18px 0 4px;\n    font-size: 0.82rem;\n    color: rgba(255, 255, 255, 0.3);\n}\n\n.compliance-transfers__empty-icon {\n    font-size: 1.1rem;\n    line-height: 1;\n    flex-shrink: 0;\n}\n\n.compliance-transfers__empty--loading {\n    color: rgba(192, 159, 83, 0.55);\n}\n\n.compliance-transfers__empty--clean {\n    color: rgba(120, 200, 140, 0.7);\n}\n\n/* Transfer rows */\n.compliance-transfers__list {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.compliance-transfers__row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px 14px;\n    border-radius: 8px;\n    border: 1px solid rgba(255, 80, 80, 0.15);\n    background: rgba(255, 60, 60, 0.05);\n}\n\n.compliance-transfers__row-main {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    flex: 1;\n    min-width: 0;\n}\n\n.compliance-transfers__row-service {\n    font-size: 0.88rem;\n    font-weight: 600;\n    color: rgba(255, 255, 255, 0.82);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.compliance-transfers__row-host {\n    font-size: 0.7rem;\n    color: rgba(255, 255, 255, 0.3);\n    font-family: monospace;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* Category badge */\n.compliance-transfers__row-cat {\n    flex-shrink: 0;\n    padding: 3px 9px;\n    border-radius: 20px;\n    font-size: 0.65rem;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    border: 1px solid transparent;\n}\n\n.compliance-transfers__row-cat--advertising {\n    background: rgba(220, 80, 80, 0.12);\n    border-color: rgba(220, 80, 80, 0.3);\n    color: rgba(240, 140, 130, 0.9);\n}\n\n.compliance-transfers__row-cat--analytics {\n    background: rgba(100, 160, 220, 0.1);\n    border-color: rgba(100, 160, 220, 0.25);\n    color: rgba(140, 190, 240, 0.85);\n}\n\n.compliance-transfers__row-cat--social {\n    background: rgba(130, 100, 200, 0.1);\n    border-color: rgba(130, 100, 200, 0.25);\n    color: rgba(175, 150, 230, 0.85);\n}\n\n.compliance-transfers__row-cat--other,\n.compliance-transfers__row-cat--unknown {\n    background: rgba(255, 255, 255, 0.04);\n    border-color: rgba(255, 255, 255, 0.1);\n    color: rgba(255, 255, 255, 0.35);\n}\n\n/* Pre-consent flag */\n.compliance-transfers__row-flag {\n    flex-shrink: 0;\n    padding: 3px 9px;\n    border-radius: 20px;\n    font-size: 0.65rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    background: rgba(220, 100, 60, 0.12);\n    border: 1px solid rgba(220, 100, 60, 0.3);\n    color: rgba(240, 160, 120, 0.9);\n}\n\n@media (max-width: 580px) {\n    .compliance-transfers__header {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .compliance-transfers__scan-btn {\n        align-self: flex-start;\n    }\n\n    .compliance-transfers__row {\n        flex-wrap: wrap;\n    }\n}\n\n/* ── Side-by-side grid ───────────────────────────────────────────────────────── */\n.compliance-bottom-grid {\n    display: grid;\n    grid-template-columns: 3fr 2fr;\n    gap: 24px;\n    align-items: start;\n}\n\n/* When the transfers card is absent (combined view), audit takes full width */\n.compliance-bottom-grid > .compliance-page__audit:first-child {\n    grid-column: 1 / -1;\n}\n\n@media (max-width: 900px) {\n    .compliance-bottom-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n.compliance-page__audit .audit-snapshot-card:hover {\n    transform: none;\n    border-color: rgba(255, 255, 255, 0.1);\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.16);\n}\n\n@media (max-width: 680px) {\n    .compliance-hero {\n        max-height: 60vw;\n        min-height: 240px;\n    }\n\n    .compliance-hero__stats {\n        flex-wrap: wrap;\n        gap: 10px 0;\n        padding: 12px 16px 16px;\n    }\n\n    .compliance-hero__stat-divider {\n        display: none;\n    }\n\n    .compliance-hero__audit-btn {\n        margin-left: 0;\n        width: 100%;\n        text-align: center;\n    }\n}\n\n/* ── Tab switcher ────────────────────────────────────────────────────────────── */\n.compliance-transfers__tabs {\n    display: flex;\n    gap: 2px;\n    margin-bottom: 20px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.07);\n    padding-bottom: 0;\n}\n\n.compliance-transfers__tab {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    padding: 8px 14px 10px;\n    background: transparent;\n    border: none;\n    border-bottom: 2px solid transparent;\n    color: rgba(255, 255, 255, 0.35);\n    font-size: 0.8rem;\n    font-weight: 600;\n    font-family: inherit;\n    cursor: pointer;\n    letter-spacing: 0.02em;\n    margin-bottom: -1px;\n    transition: color 0.15s ease, border-color 0.15s ease;\n}\n\n.compliance-transfers__tab:hover {\n    color: rgba(255, 255, 255, 0.6);\n}\n\n.compliance-transfers__tab.--active {\n    color: rgba(255, 255, 255, 0.88);\n    border-bottom-color: #c0a053;\n}\n\n.compliance-tab-pill {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 18px;\n    height: 18px;\n    padding: 0 5px;\n    border-radius: 9px;\n    font-size: 0.62rem;\n    font-weight: 700;\n    background: rgba(255, 255, 255, 0.08);\n    color: rgba(255, 255, 255, 0.45);\n}\n\n.compliance-transfers__tab.--active .compliance-tab-pill {\n    background: rgba(192, 159, 83, 0.18);\n    color: rgba(192, 159, 83, 0.9);\n}\n\n/* ── Cookies list ────────────────────────────────────────────────────────────── */\n.compliance-cookies__list {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.compliance-cookies__row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 14px;\n    border-radius: 8px;\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    background: rgba(255, 255, 255, 0.02);\n}\n\n.compliance-cookies__row-main {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    flex: 1;\n    min-width: 0;\n}\n\n.compliance-cookies__row-name {\n    font-size: 0.82rem;\n    font-weight: 600;\n    font-family: monospace;\n    color: rgba(255, 255, 255, 0.78);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.compliance-cookies__row-domain {\n    font-size: 0.68rem;\n    color: rgba(255, 255, 255, 0.28);\n    font-family: monospace;\n    white-space: pre-wrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.compliance-cookies__row-desc {\n    font-size: 0.68rem;\n    color: rgba(255, 255, 255, 0.38);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-style: italic;\n}\n\n.compliance-cookies__row-party {\n    flex-shrink: 0;\n    padding: 3px 9px;\n    border-radius: 20px;\n    font-size: 0.62rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    border: 1px solid transparent;\n}\n\n.compliance-cookies__row-party.--third {\n    background: rgba(220, 80, 80, 0.1);\n    border-color: rgba(220, 80, 80, 0.25);\n    color: rgba(240, 130, 120, 0.85);\n}\n\n.compliance-cookies__row-party.--first {\n    background: rgba(255, 255, 255, 0.04);\n    border-color: rgba(255, 255, 255, 0.1);\n    color: rgba(255, 255, 255, 0.35);\n}\n\n.compliance-cookies__row-lifetime {\n    flex-shrink: 0;\n    font-size: 0.65rem;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n}\n\n.compliance-cookies__row-lifetime.--persistent {\n    color: rgba(220, 160, 60, 0.75);\n}\n\n.compliance-cookies__row-lifetime.--session {\n    color: rgba(255, 255, 255, 0.28);\n}\n\n.compliance-cookies__flags {\n    display: flex;\n    gap: 4px;\n    flex-shrink: 0;\n    flex-wrap: wrap;\n}\n\n.compliance-cookies__flag {\n    padding: 2px 7px;\n    border-radius: 4px;\n    font-size: 0.58rem;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    background: rgba(80, 144, 220, 0.08);\n    border: 1px solid rgba(80, 144, 220, 0.18);\n    color: rgba(140, 190, 240, 0.7);\n}\n\n@media (max-width: 580px) {\n    .compliance-cookies__row {\n        flex-wrap: wrap;\n    }\n    .compliance-cookies__flags {\n        width: 100%;\n    }\n}\n\n/* ── Category summary cards ─────────────────────────────────────────────────── */\n.transfers-summary {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-bottom: 18px;\n}\n\n.transfers-summary__card {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n    padding: 12px 18px 10px;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.07);\n    background: rgba(255, 255, 255, 0.02);\n    cursor: pointer;\n    font-family: inherit;\n    color: inherit;\n    transition: background 0.15s ease, border-color 0.15s ease;\n    min-width: 76px;\n    text-align: center;\n}\n\n.transfers-summary__card:hover {\n    background: rgba(255, 255, 255, 0.05);\n    border-color: rgba(255, 255, 255, 0.13);\n}\n\n.transfers-summary__card.--active {\n    background: color-mix(in srgb, var(--cat-color, #c0a053) 12%, transparent);\n    border-color: color-mix(in srgb, var(--cat-color, #c0a053) 40%, transparent);\n}\n\n.transfers-summary__card-icon {\n    font-size: 0.9rem;\n    line-height: 1;\n    color: var(--cat-color, rgba(255, 255, 255, 0.5));\n}\n\n.transfers-summary__card-count {\n    font-size: 1.6rem;\n    font-weight: 200;\n    color: rgba(255, 255, 255, 0.88);\n    line-height: 1;\n    font-variant-numeric: tabular-nums;\n    letter-spacing: -0.02em;\n}\n\n.transfers-summary__card-label {\n    font-size: 0.6rem;\n    font-weight: 700;\n    letter-spacing: 0.09em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.35);\n}\n\n.transfers-summary__card-risk {\n    font-size: 0.58rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    padding: 2px 7px;\n    border-radius: 10px;\n    margin-top: 2px;\n}\n\n.transfers-summary__card-risk.--high {\n    background: rgba(220, 80, 80, 0.15);\n    color: rgba(240, 130, 120, 0.9);\n}\n\n.transfers-summary__card-risk.--medium {\n    background: rgba(220, 160, 60, 0.12);\n    color: rgba(230, 180, 100, 0.85);\n}\n\n.transfers-summary__card-risk.--low {\n    background: rgba(80, 168, 120, 0.1);\n    color: rgba(120, 200, 150, 0.75);\n}\n\n.transfers-summary__clear {\n    align-self: center;\n    padding: 6px 14px;\n    border-radius: 6px;\n    border: 1px solid rgba(255, 255, 255, 0.09);\n    background: transparent;\n    color: rgba(255, 255, 255, 0.35);\n    font-size: 0.72rem;\n    font-family: inherit;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.transfers-summary__clear:hover {\n    background: rgba(255, 255, 255, 0.05);\n    color: rgba(255, 255, 255, 0.6);\n}\n\n/* ── Row additions ───────────────────────────────────────────────────────────── */\n.compliance-transfers__row-icon {\n    flex-shrink: 0;\n    font-size: 0.85rem;\n    width: 18px;\n    text-align: center;\n    line-height: 1;\n}\n\n.compliance-transfers__row-resource {\n    flex-shrink: 0;\n    padding: 2px 8px;\n    border-radius: 5px;\n    font-size: 0.6rem;\n    font-weight: 700;\n    letter-spacing: 0.07em;\n    text-transform: uppercase;\n    background: rgba(255, 255, 255, 0.05);\n    color: rgba(255, 255, 255, 0.3);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    white-space: nowrap;\n}\n\n.compliance-transfers__row-resource--script   { background: rgba(120, 100, 220, 0.1); border-color: rgba(120, 100, 220, 0.2); color: rgba(170, 155, 240, 0.75); }\n.compliance-transfers__row-resource--xhr,\n.compliance-transfers__row-resource--fetch    { background: rgba(220, 160, 60, 0.08); border-color: rgba(220, 160, 60, 0.18); color: rgba(230, 185, 100, 0.7);  }\n.compliance-transfers__row-resource--image    { background: rgba(80, 168, 120, 0.07); border-color: rgba(80, 168, 120, 0.16); color: rgba(120, 200, 150, 0.65); }\n.compliance-transfers__row-resource--font     { background: rgba(255, 255, 255, 0.04); border-color: rgba(255, 255, 255, 0.09); color: rgba(255, 255, 255, 0.28); }\n.compliance-transfers__row-resource--stylesheet { background: rgba(80, 144, 220, 0.07); border-color: rgba(80, 144, 220, 0.16); color: rgba(140, 190, 240, 0.65); }\n\n/* ── EU / Non-EU region badge ────────────────────────────────────────────────── */\n.compliance-transfers__row-region {\n    flex-shrink: 0;\n    padding: 2px 8px;\n    border-radius: 5px;\n    font-size: 0.6rem;\n    font-weight: 700;\n    letter-spacing: 0.07em;\n    text-transform: uppercase;\n    white-space: nowrap;\n    border: 1px solid transparent;\n}\n\n.compliance-transfers__row-region.--eu {\n    background: rgba(80, 168, 120, 0.08);\n    border-color: rgba(80, 168, 120, 0.2);\n    color: rgba(120, 200, 150, 0.7);\n}\n\n.compliance-transfers__row-region.--non-eu {\n    background: rgba(220, 140, 50, 0.1);\n    border-color: rgba(220, 140, 50, 0.22);\n    color: rgba(230, 175, 100, 0.8);\n}\n\n/* ── Extra category colours ──────────────────────────────────────────────────── */\n.compliance-transfers__row--cmp {\n    border-color: rgba(80, 168, 120, 0.12);\n    background: rgba(80, 168, 120, 0.03);\n}\n\n.compliance-transfers__row-cat--cmp {\n    background: rgba(80, 168, 120, 0.1);\n    border-color: rgba(80, 168, 120, 0.25);\n    color: rgba(120, 200, 150, 0.85);\n}\n\n.compliance-transfers__row-cat--fingerprinting {\n    background: rgba(192, 54, 90, 0.12);\n    border-color: rgba(192, 54, 90, 0.3);\n    color: rgba(230, 120, 150, 0.9);\n}\n\n.compliance-transfers__row-cat--functional {\n    background: rgba(80, 168, 120, 0.08);\n    border-color: rgba(80, 168, 120, 0.2);\n    color: rgba(120, 200, 150, 0.8);\n}\n\n.compliance-transfers__row-cat--cdn {\n    background: rgba(150, 150, 150, 0.07);\n    border-color: rgba(150, 150, 150, 0.18);\n    color: rgba(180, 180, 180, 0.55);\n}\n\n.compliance-transfers__row-cat--third-party {\n    background: rgba(255, 255, 255, 0.04);\n    border-color: rgba(255, 255, 255, 0.1);\n    color: rgba(255, 255, 255, 0.32);\n}\n\n@media (max-width: 580px) {\n    .transfers-summary {\n        gap: 6px;\n    }\n\n    .transfers-summary__card {\n        min-width: 64px;\n        padding: 10px 12px 8px;\n    }\n\n    .compliance-transfers__row-resource,\n    .compliance-transfers__row-region {\n        display: none;\n    }\n}\n\n/* ── Combined-view placeholder ──────────────────────────────────────────────── */\n.compliance-transfers__combined-placeholder {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    padding: 28px 22px;\n    color: rgba(255, 255, 255, 0.3);\n    font-size: 0.82rem;\n    line-height: 1.5;\n}\n\n.compliance-transfers__combined-placeholder p {\n    margin: 0;\n    max-width: 440px;\n}\n\n.compliance-transfers__combined-placeholder-icon {\n    font-size: 1.4rem;\n    flex-shrink: 0;\n    opacity: 0.35;\n}\n\n/* ── Header actions (export + scan) ─────────────────────────────────────────── */\n.compliance-transfers__header-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n}\n\n.compliance-transfers__export-btn {\n    padding: 8px 14px;\n    border-radius: 8px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    background: rgba(255, 255, 255, 0.04);\n    color: rgba(255, 255, 255, 0.45);\n    font-size: 0.75rem;\n    font-weight: 600;\n    font-family: inherit;\n    cursor: pointer;\n    letter-spacing: 0.02em;\n    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n    white-space: nowrap;\n}\n\n.compliance-transfers__export-btn:hover {\n    background: rgba(255, 255, 255, 0.08);\n    border-color: rgba(255, 255, 255, 0.18);\n    color: rgba(255, 255, 255, 0.75);\n}\n\n/* ── Cookie table actions ────────────────────────────────────────────────────── */\n.compliance-cookies__table-actions {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 8px;\n}\n\n/* ── Scan history ────────────────────────────────────────────────────────────── */\n.compliance-transfers__history {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 6px;\n    padding: 10px 0 16px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n    margin-bottom: 4px;\n}\n\n.compliance-transfers__history-label {\n    font-size: 0.65rem;\n    font-weight: 700;\n    letter-spacing: 0.09em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.2);\n    margin-right: 4px;\n    flex-shrink: 0;\n}\n\n.compliance-transfers__history-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 10px;\n    border-radius: 6px;\n    border: 1px solid rgba(255, 255, 255, 0.07);\n    background: rgba(255, 255, 255, 0.02);\n    font-size: 0.7rem;\n    color: rgba(255, 255, 255, 0.35);\n}\n\n.compliance-transfers__history-chip-detail {\n    color: rgba(255, 255, 255, 0.2);\n}\n\n/* ── Search input ────────────────────────────────────────────────────────────── */\n.compliance-search {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 10px;\n}\n\n.compliance-search__input {\n    flex: 1;\n    padding: 8px 12px;\n    border-radius: 7px;\n    border: 1px solid rgba(255, 255, 255, 0.09);\n    background: rgba(255, 255, 255, 0.03);\n    color: rgba(255, 255, 255, 0.75);\n    font-size: 0.8rem;\n    font-family: inherit;\n    outline: none;\n    transition: border-color 0.15s ease, background 0.15s ease;\n    min-width: 0;\n}\n\n.compliance-search__input::placeholder {\n    color: rgba(255, 255, 255, 0.2);\n}\n\n.compliance-search__input:focus {\n    border-color: rgba(192, 159, 83, 0.4);\n    background: rgba(255, 255, 255, 0.05);\n}\n\n.compliance-search__input::-webkit-search-cancel-button {\n    filter: invert(0.5);\n    cursor: pointer;\n}\n\n.compliance-search__count {\n    font-size: 0.68rem;\n    color: rgba(255, 255, 255, 0.3);\n    white-space: nowrap;\n    flex-shrink: 0;\n}\n\n/* ── List column headers ─────────────────────────────────────────────────────── */\n.compliance-transfers__list-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 4px 14px 6px;\n    font-size: 0.6rem;\n    font-weight: 700;\n    letter-spacing: 0.09em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.2);\n}\n\n.compliance-transfers__list-header > span:first-child { width: 18px; flex-shrink: 0; }\n.compliance-transfers__list-header > span:nth-child(2) { flex: 1; min-width: 0; }\n.compliance-transfers__list-header > span:last-child   { width: 18px; flex-shrink: 0; }\n\n.compliance-cookies__list-header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 4px 14px 6px;\n    font-size: 0.6rem;\n    font-weight: 700;\n    letter-spacing: 0.09em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.2);\n}\n\n.compliance-cookies__list-header > span:first-child { flex: 1; min-width: 0; }\n\n/* ── Expandable transfer rows ────────────────────────────────────────────────── */\n.compliance-transfers__row-wrap {\n    display: flex;\n    flex-direction: column;\n}\n\n.compliance-transfers__row {\n    cursor: pointer;\n    transition: background 0.12s ease, border-color 0.12s ease;\n}\n\n.compliance-transfers__row:hover,\n.compliance-transfers__row.--expanded {\n    background: rgba(255, 80, 80, 0.08);\n    border-color: rgba(255, 80, 80, 0.22);\n}\n\n.compliance-transfers__row-toggle {\n    flex-shrink: 0;\n    font-size: 0.65rem;\n    color: rgba(255, 255, 255, 0.25);\n    width: 14px;\n    text-align: center;\n    transition: color 0.12s ease;\n}\n\n.compliance-transfers__row:hover .compliance-transfers__row-toggle,\n.compliance-transfers__row.--expanded .compliance-transfers__row-toggle {\n    color: rgba(255, 255, 255, 0.5);\n}\n\n.compliance-transfers__row-detail {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px 20px;\n    padding: 10px 14px 12px 44px;\n    border: 1px solid rgba(255, 80, 80, 0.12);\n    border-top: none;\n    border-radius: 0 0 8px 8px;\n    background: rgba(255, 255, 255, 0.02);\n}\n\n.compliance-transfers__row-detail-item {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n    font-size: 0.75rem;\n    color: rgba(255, 255, 255, 0.55);\n}\n\n.compliance-transfers__row-detail-item--full {\n    width: 100%;\n}\n\n.compliance-transfers__row-detail-label {\n    font-size: 0.58rem;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.2);\n}\n\n.compliance-transfers__row-detail-code {\n    font-family: monospace;\n    font-size: 0.72rem;\n    color: rgba(192, 159, 83, 0.75);\n    word-break: break-all;\n    white-space: pre-wrap;\n}\n\n.compliance-transfers__row-detail-privacy {\n    font-size: 0.72rem;\n    color: rgba(80, 144, 220, 0.8);\n    text-decoration: none;\n}\n.compliance-transfers__row-detail-privacy:hover {\n    color: rgba(80, 144, 220, 1);\n    text-decoration: underline;\n}\n\n/* ── Consent / banner category badge ────────────────────────────────────────── */\n.compliance-banner-cat {\n    flex-shrink: 0;\n    padding: 2px 8px;\n    border-radius: 5px;\n    font-size: 0.6rem;\n    font-weight: 700;\n    letter-spacing: 0.07em;\n    text-transform: uppercase;\n    white-space: nowrap;\n    border: 1px solid color-mix(in srgb, var(--bc-color, #909090) 35%, transparent);\n    background: color-mix(in srgb, var(--bc-color, #909090) 10%, transparent);\n    color: color-mix(in srgb, var(--bc-color, #909090) 90%, #fff);\n}\n\n/* ── Pagination controls ─────────────────────────────────────────────────────── */\n.compliance-pagination {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    padding: 14px 0 2px;\n}\n\n.compliance-pagination__btn {\n    padding: 5px 14px;\n    border-radius: 6px;\n    border: 1px solid rgba(255, 255, 255, 0.09);\n    background: transparent;\n    color: rgba(255, 255, 255, 0.45);\n    font-size: 0.75rem;\n    font-family: inherit;\n    cursor: pointer;\n    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n\n.compliance-pagination__btn:hover:not(:disabled) {\n    background: rgba(255, 255, 255, 0.06);\n    color: rgba(255, 255, 255, 0.75);\n    border-color: rgba(255, 255, 255, 0.16);\n}\n\n.compliance-pagination__btn:disabled {\n    opacity: 0.25;\n    cursor: not-allowed;\n}\n\n.compliance-pagination__info {\n    font-size: 0.72rem;\n    color: rgba(255, 255, 255, 0.3);\n    font-variant-numeric: tabular-nums;\n    min-width: 52px;\n    text-align: center;\n}\n\n/* ── Embed modal ─────────────────────────────────────────────────────────────── */\n.compliance-embed-modal__overlay {\n    position: fixed;\n    inset: 0;\n    z-index: 1000;\n    background: rgba(0, 0, 0, 0.65);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 24px;\n}\n\n.compliance-embed-modal {\n    background: #1a1a2e;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 12px;\n    padding: 28px 28px 24px;\n    width: 100%;\n    max-width: 560px;\n    box-shadow: 0 24px 64px rgba(0, 0, 0, 0.5);\n}\n\n.compliance-embed-modal__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 12px;\n}\n\n.compliance-embed-modal__title {\n    font-size: 0.95rem;\n    font-weight: 700;\n    color: rgba(255, 255, 255, 0.9);\n    margin: 0;\n}\n\n.compliance-embed-modal__close {\n    background: none;\n    border: none;\n    color: rgba(255, 255, 255, 0.35);\n    font-size: 1rem;\n    cursor: pointer;\n    padding: 4px;\n    line-height: 1;\n    transition: color 0.15s ease;\n}\n\n.compliance-embed-modal__close:hover {\n    color: rgba(255, 255, 255, 0.75);\n}\n\n.compliance-embed-modal__desc {\n    font-size: 0.82rem;\n    color: rgba(255, 255, 255, 0.5);\n    margin: 0 0 16px;\n    line-height: 1.55;\n}\n\n.compliance-embed-modal__desc strong {\n    color: rgba(255, 255, 255, 0.8);\n    font-weight: 600;\n}\n\n.compliance-embed-modal__code {\n    background: rgba(0, 0, 0, 0.35);\n    border: 1px solid rgba(255, 255, 255, 0.07);\n    border-radius: 8px;\n    padding: 14px 16px;\n    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n    font-size: 0.75rem;\n    color: rgba(255, 255, 255, 0.75);\n    white-space: pre-wrap;\n    word-break: break-all;\n    margin: 0 0 16px;\n    line-height: 1.6;\n}\n\n.compliance-embed-modal__actions {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 14px;\n}\n\n.compliance-embed-modal__copy-btn {\n    padding: 9px 18px;\n    border-radius: 8px;\n    border: none;\n    background: rgba(255, 255, 255, 0.1);\n    color: rgba(255, 255, 255, 0.85);\n    font-size: 0.8rem;\n    font-weight: 600;\n    font-family: inherit;\n    cursor: pointer;\n    letter-spacing: 0.02em;\n    transition: background 0.15s ease, color 0.15s ease;\n}\n\n.compliance-embed-modal__copy-btn:hover {\n    background: rgba(255, 255, 255, 0.16);\n}\n\n.compliance-embed-modal__hint {\n    font-size: 0.75rem;\n    color: rgba(255, 255, 255, 0.28);\n    margin: 0;\n    line-height: 1.5;\n}\n\n.compliance-embed-modal__hint code {\n    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n    font-size: 0.72rem;\n    background: rgba(255, 255, 255, 0.06);\n    padding: 1px 5px;\n    border-radius: 4px;\n}\n\n/* ── Cookie table actions gap ────────────────────────────────────────────────── */\n.compliance-cookies__table-actions {\n    gap: 8px;\n}\n\n/* ── Cookie row wrap ─────────────────────────────────────────────────────────── */\n.compliance-cookies__row-wrap {\n    display: flex;\n    flex-direction: column;\n}\n\n.compliance-cookies__row--unknown {\n    border-color: rgba(220, 160, 60, 0.2);\n    background: rgba(220, 160, 60, 0.04);\n    border-left: 3px solid rgba(220, 160, 60, 0.35);\n}\n\n/* ── Vendor line in cookie row ───────────────────────────────────────────────── */\n.compliance-cookies__row-vendor {\n    font-size: 0.65rem;\n    color: rgba(192, 159, 83, 0.7);\n    font-weight: 600;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* ── Unknown category badge ──────────────────────────────────────────────────── */\n.compliance-cookies__unknown-badge {\n    flex-shrink: 0;\n    padding: 2px 8px;\n    border-radius: 5px;\n    font-size: 0.6rem;\n    font-weight: 700;\n    letter-spacing: 0.07em;\n    text-transform: uppercase;\n    white-space: nowrap;\n    border: 1px solid rgba(220, 160, 60, 0.22);\n    background: rgba(220, 160, 60, 0.06);\n    color: rgba(230, 180, 100, 0.55);\n}\n\n/* ── Edit button on cookie row ───────────────────────────────────────────────── */\n.compliance-cookies__edit-btn {\n    flex-shrink: 0;\n    background: rgba(255, 255, 255, 0.03);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 5px;\n    color: rgba(255, 255, 255, 0.3);\n    font-size: 0.8rem;\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    font-family: inherit;\n    padding: 0;\n    line-height: 1;\n    transition: color 0.12s ease, border-color 0.12s ease, background 0.12s ease;\n}\n\n.compliance-cookies__row--unknown .compliance-cookies__edit-btn {\n    background: rgba(220, 160, 60, 0.07);\n    border-color: rgba(220, 160, 60, 0.25);\n    color: rgba(220, 160, 60, 0.6);\n}\n\n.compliance-cookies__edit-btn:hover,\n.compliance-cookies__edit-btn.--active {\n    color: rgba(192, 159, 83, 0.9);\n    border-color: rgba(192, 159, 83, 0.35);\n    background: rgba(192, 159, 83, 0.08);\n}\n\n/* ── Inline edit panel ───────────────────────────────────────────────────────── */\n.compliance-cookies__edit-panel {\n    display: flex;\n    align-items: flex-end;\n    gap: 10px;\n    padding: 10px 14px 12px;\n    border: 1px solid rgba(192, 159, 83, 0.15);\n    border-top: none;\n    border-radius: 0 0 8px 8px;\n    background: rgba(192, 159, 83, 0.03);\n    flex-wrap: wrap;\n}\n\n.compliance-cookies__edit-fields {\n    display: flex;\n    gap: 10px;\n    flex: 1;\n    flex-wrap: wrap;\n    min-width: 0;\n}\n\n.compliance-cookies__edit-field {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 120px;\n}\n\n.compliance-cookies__edit-field--wide {\n    flex: 1;\n    min-width: 180px;\n}\n\n.compliance-cookies__edit-label {\n    font-size: 0.58rem;\n    font-weight: 700;\n    letter-spacing: 0.09em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.22);\n}\n\n.compliance-cookies__edit-input,\n.compliance-cookies__edit-select {\n    padding: 6px 10px;\n    border-radius: 6px;\n    border: 1px solid rgba(255, 255, 255, 0.09);\n    background: rgba(255, 255, 255, 0.04);\n    color: rgba(255, 255, 255, 0.75);\n    font-size: 0.78rem;\n    font-family: inherit;\n    outline: none;\n    transition: border-color 0.15s ease;\n}\n\n.compliance-cookies__edit-input:focus,\n.compliance-cookies__edit-select:focus {\n    border-color: rgba(192, 159, 83, 0.4);\n}\n\n.compliance-cookies__edit-select option {\n    background: #1a1a2e;\n    color: rgba(255, 255, 255, 0.75);\n}\n\n.compliance-cookies__edit-actions {\n    display: flex;\n    gap: 6px;\n    flex-shrink: 0;\n    align-items: flex-end;\n}\n\n.compliance-cookies__edit-save {\n    padding: 6px 14px;\n    border-radius: 6px;\n    border: 1px solid rgba(192, 159, 83, 0.35);\n    background: rgba(192, 159, 83, 0.1);\n    color: #c0a053;\n    font-size: 0.75rem;\n    font-weight: 600;\n    font-family: inherit;\n    cursor: pointer;\n    letter-spacing: 0.02em;\n    transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.compliance-cookies__edit-save:hover {\n    background: rgba(192, 159, 83, 0.18);\n    border-color: rgba(192, 159, 83, 0.55);\n}\n\n.compliance-cookies__edit-cancel {\n    padding: 6px 12px;\n    border-radius: 6px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: transparent;\n    color: rgba(255, 255, 255, 0.35);\n    font-size: 0.75rem;\n    font-family: inherit;\n    cursor: pointer;\n    transition: color 0.15s ease, background 0.15s ease;\n}\n\n.compliance-cookies__edit-cancel:hover {\n    background: rgba(255, 255, 255, 0.05);\n    color: rgba(255, 255, 255, 0.6);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
